import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
    ObtenerEstadisticaGeneral(vm, data) {
        return axios
            .post(
                `${domain.domainNameForApi}Operacion/ObtenerEstadisticaGeneralExcel`,
                data
            )
            .then((response) => response.data);
    },
    ObtenerEstadisticaGeneral(vm, data) {
        return axios
            .post(
                `${domain.domainNameForApi}Operacion/ObtenerEstadisticaGeneralExcel`,
                data
            )
            .then((response) => response.data);
    },
    Aseguradora(vm, data) {
        return axios
            .post(`${domain.domainNameForApi}Operacion/Aseguradora`, data).then((response) => response.data);
    },
    //Perfil(vm) {
    //    return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/DashboardPerfil`).then(response => response.data);
    //},
     Perfil(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/OperacionPerfil`).then(response => response.data);
    },
    ObtenerDatosJuridico(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObtenerDatosJuridico`, data).then(response => response.data);
    },
    ObtenerDetalle(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObtenerDetalle`, data).then(response => response.data);
    },
    ObtenerAbogados(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObtenerAbogados`, data).then(response => response.data);
    },
    ObtenerDetalleExcel(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObtenerDetalleExcel`, data).then(response => response.data);
    },
    ObtenerFlotilla(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObtenerFlotilla`, data).then(response => response.data);
    },
    ObtenerDatosRLV(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObtenerDatosRLV`, data).then(response => response.data);
    },
    ObtenerDatosAsistencia(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObtenerDatosAsistencia`, data).then(response => response.data);
    },
    ClientesPoderes(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ClientesPoderes`).then(response => response.data);
    },
    ListadoProveedor(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ListadoProveedor`).then(response => response.data);
    },
    ValidarNum(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ValidarNum`, data).then(response => response.data);
    },
    GuardarPoderes(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/GuardarPoderes`, data).then(response => response.data);
    },
    BusquedaPoder(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/BusquedaPoder`, data).then(response => response.data);
    },
    ListadoUsuarios(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ListadoUsuarios`, data).then(response => response.data);
    },
    ListadoFlotilla(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ListadoFlotilla`, data).then(response => response.data);
    },
    ListadoEstado(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ListadoEstado`, data).then(response => response.data);
    },
    DetallePoder(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/DetallePoder`, data).then(response => response.data);
    },
    ListadoEstatus(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ListadoEstatus`).then(response => response.data);
    },
    AltaMovimiento(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/AltaMovimiento`, data).then(response => response.data);
    },
    ValidarReporteIndice(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ValidarReporteIndice`, data).then(response => response.data);
    },
    DescargarArchivo(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/DescargarArchivo`, data).then(response => response.data);
    },
    
}